import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useSidebar } from "@/components/ui/sidebar";
import { Logo } from './header/Logo';
import { NotificationsMenu } from './header/NotificationsMenu';
import { SubscriptionButton } from './header/SubscriptionButton';
import { useAuth } from "@/hooks/useAuth";

export const Header: FC = () => {
  const { toggleSidebar } = useSidebar();
  const { user, profile } = useAuth();

  return (
    <header className="w-full bg-white shadow-sm py-2 relative z-50">
      <div className="container mx-auto px-2 md:pl-[calc(var(--sidebar-width)_+_0.5rem)] flex items-center justify-between transition-all duration-300">
        <div className="flex items-center gap-2">
          <button
            onClick={toggleSidebar}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors md:hidden"
            aria-label="Toggle Menu"
          >
            <Menu className="h-6 w-6 text-gray-600" />
          </button>
          <Link to={user ? "/dashboard" : "/"} className="flex items-center">
            <Logo />
          </Link>
        </div>
        
        <div className="flex items-center gap-2">
          {user && profile && (
            <>
              <SubscriptionButton profile={profile} />
              <NotificationsMenu />
            </>
          )}
        </div>
      </div>
    </header>
  );
};